
import { defineComponent,getCurrentInstance, onMounted, reactive, toRefs,watch } from 'vue'
import {useRouter, useRoute, RouteLocationMatched, onBeforeRouteUpdate} from 'vue-router';
import {useStore} from 'vuex'
import searchBtn from './searchEl.vue'
export default defineComponent({
    components:{searchBtn},
    setup(props,{emit}) {
        const {proxy,appContext}= getCurrentInstance() as any
        const route=useRoute()
        const router=useRouter()
        const store=useStore()
        const state=reactive({
            platformJson:appContext.config.globalProperties.platformJson,
        })
        const methods=reactive({
            windowResize:()=>{
                let clientHeight=proxy.$refs.searchRef?.clientHeight
                console.log(clientHeight,'顶部高度')
                if(clientHeight&&clientHeight>0){
                    store.commit('SET_SEARCH_TOP',clientHeight-115)
                }
            },
            searchValue:(val:String)=>{
                emit('searchValue',val)
            }
        })
        console.log(route.path,'pagh')
        onMounted(()=>{
            store.commit('SET_SEARCH_TOP',proxy.$refs.searchRef.clientHeight-115)
            window.addEventListener('resize',methods.windowResize,true)
        })
        return {
            ...toRefs(state),
            ...toRefs(methods)
        }
    },
})
